import React, { useContext, useEffect, useState } from "react";
import {
    GoogleMap,
    Marker,
    useJsApiLoader, InfoWindow,
    DirectionsRenderer,
} from "@react-google-maps/api";
import AuthContext from "context/AuthContext";
import { useTranslation } from "react-i18next";
import helpers from "utils/helpers";
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { emitEvent } from "utils/initializeSocket";
import { isEmpty } from "lodash";
import { FaCircleArrowLeft } from "react-icons/fa6";
const containerStyle = {
    width: "100%",
    height: "780px",
};

const libraries = ["places"];

const LiveTrackingWithRoute = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [pickupLocation, setPickupLocation] = useState()
    const { updatePageName, socket } = useContext(AuthContext);
    const [dropoff, setDropoff] = useState();

    const { t } = useTranslation();
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries,

    });

    useEffect(() => {
        updatePageName(t("LIVE_TRACKING"));
    }, []);

    const [directions, setDirections] = useState(null);

    useEffect(() => {
        if (isEmpty(location?.state)) {
            navigate('/service-monitoring')
        } else if (isLoaded) {
            setTimeout(() => { setPickupLocation({ lat: location?.state?.location?.coordinates?.[1], lng: location?.state?.location?.coordinates?.[0] }) }, 100)
        }
    }, [location, isLoaded])

    const fetchDirections = (location) => {
        let dropLocation = { lat: location?.latitude, lng: location?.longitude }
        const service = new window.google.maps.DirectionsService();
        service.route(
            {
                origin: pickupLocation,
                destination: dropLocation,
                travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    setDirections(result);
                    const leg = result?.routes?.[0]?.legs?.[0];
                    setDropoff({ lat: leg?.end_location?.lat(), lng: leg?.end_location?.lng() });
                } else {
                    console.error("Error fetching directions", result);
                }
            }
        );
    };
    const listenNotification = (state) => {
        emitEvent(socket, 'getDriverLocation', { bookingId: state?._id }, (data) => {
            if (helpers.andOperator(data?.success, isLoaded)) {
                fetchDirections(data);
            }

        });
    }
    useEffect(() => {
        if (socket) {
            const intervalId = setInterval(() => {
                listenNotification(location.state);
            }, 1000);

            return () => clearInterval(intervalId);
        }
    }, [socket, location, isLoaded, pickupLocation]);



    const [infoWindow, setInfoWindow] = useState({
        position: null,
        address: '',
        type: ''
    });

    const handleMarkerClick = (position, type) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: position }, (results, status) => {
            if (status === 'OK' && results[0]) {
                setInfoWindow({
                    position,
                    address: results[0].formatted_address,
                    type: type
                });
            } else {
                setInfoWindow({
                    position,
                    address: 'Address not found',
                    type: type
                });
            }
        });
    };

    return (
        <div className="p-4">
            <div className="flex active mb-5 ml-4 ">
                <Link aria-current="page" className="" to={-1}>
                    <FaCircleArrowLeft size={27} />
                </Link>
            </div>
            {helpers.ternaryCondition(!isLoaded,
                <div className="w-full h-[936px] bg-gray-200 animate-pulse rounded-lg mb-3 mt-3 flex justify-center items-center">{t('MAP_LOADING')}</div>,
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={pickupLocation}
                    options={{
                        gestureHandling: 'greedy',
                        zoomControl: true,
                        fullscreenControl: false,
                        streetViewControl: false,
                        mapTypeControl: false,
                        styles: helpers.mapStyles,
                    }}

                    zoom={helpers.ternaryCondition(directions, 20, 10)}>
                    {pickupLocation && <Marker
                        position={pickupLocation}
                        onLoad={(marker) => {
                            marker.setIcon({
                                url: '/images/pickups.png',
                                scaledSize: new window.google.maps.Size(25, 25),
                            });
                        }}

                        onClick={() => handleMarkerClick(pickupLocation, 'Service')}

                    />}
                    {dropoff && <Marker
                        position={dropoff}
                        onLoad={(marker) => {
                            marker.setIcon({
                                url: '/images/drop.png',
                                scaledSize: new window.google.maps.Size(50, 50),
                                anchor: new window.google.maps.Point(15, 15),
                            });
                        }}

                        onClick={() => handleMarkerClick(dropoff, 'Driver')}
                    />}

                    {infoWindow?.position && (
                        <InfoWindow
                            position={infoWindow?.position}
                            onCloseClick={() => setInfoWindow({ position: null, address: '', type: '' })}
                        >
                            <div style={{ maxWidth: '200px' }}>
                                <strong>{infoWindow?.type} Address:</strong>
                                <p>{infoWindow?.address}</p>
                            </div>
                        </InfoWindow>
                    )}

                    {directions && helpers.getDistanceInMeters(pickupLocation, dropoff) > 20 && <DirectionsRenderer directions={directions}
                        options={{
                            suppressMarkers: true,
                            polylineOptions: {
                                strokeColor: '#0000FF',
                                strokeOpacity: 0.8,
                                strokeWeight: 5,
                            },
                        }}
                    />}
                </GoogleMap>)}
        </div>
    );
};

export default LiveTrackingWithRoute;
